module.exports = "/_next/static/images/success-plus-graph-8a5aaebd4b1a2e42d1cb103ed13926a0.png";